import { forwardRef, useCallback, useImperativeHandle } from 'react';

export const AdyenProvider = forwardRef((props, ref) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const processPayment = useCallback(async (data: any) => new Promise(r => { r(undefined); }), []);

  useImperativeHandle(ref, () => ({
    processPayment,
  }), [processPayment]);

  return null;
});
